import ChatbotCRUDActions from '@mm/state/actions/ChatbotCRUDActions';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import {
  activeCompanySelector,
  formattedBotsSelector,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import AdditionalChatbotsPanel from './AdditionalChatbotsPanel/AdditionalChatbotsPanel';
import BotName from './BotName/BotName';
import ChatbotStatusSection from './ChatbotStatusSection/ChatbotStatusSection';
import Language from './Language/Language';
import { VIPs } from './VIPs/vips';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const BotSettingsSection = (props: Props) => {
  const { chatbot, company, bots, languages, updateChatbot } = props;

  if (chatbot) {
    return (
      <div className="bot-settings-section">
        <BotName chatbot={chatbot} />

        <ChatbotStatusSection />

        <VIPs />

        <Language
          languages={languages}
          updateChatbot={updateChatbot}
          chatbot={chatbot}
        />

        {company && <AdditionalChatbotsPanel company={company} bots={bots} />}
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state: StoreState) => ({
  chatbot: state.chatbot.activeChatbot,
  company: activeCompanySelector(state),
  bots: formattedBotsSelector(state),
  languages: state.chatbot.languages,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  updateChatbot: (entity: Partial<ChatbotModel>) =>
    dispatch(ChatbotCRUDActions.update(entity)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(BotSettingsSection);
